/**
 * Google Drive API Service - Entry Point
 *
 * Re-exports the fully composed GoogleDriveService class and singleton.
 * The class is built via inheritance chain:
 *   Core → Projects → Repository → Sharing (= GoogleDriveService)
 */

export { GoogleDriveService } from './sharing';
export type { DriveFile } from './core';

// Singleton instance — backward compatible with `import { googleDrive } from '../services/googleDrive'`
import { GoogleDriveService } from './sharing';
export const googleDrive = new GoogleDriveService();

// Drive Import (Shortcut Strategy)
export {
  importFromDriveWithReplicate,
  importBatchFromDrive,
  returnPdfToOriginalFolder,
  deleteImportShortcut,
  trashDriveFile,
  isDuplicateByFileId,
  cleanOriginalFilename,
} from './importFromDrive';
export type { ImportResult, ImportBatchResult } from './importFromDrive';
